
import React from 'react';

const ProfessionalArchitectureDiagram: React.FC = () => {
  const ComponentBox: React.FC<{
    title: string;
    x: number;
    y: number;
    width: number;
    height: number;
    bgColor: string;
    textColor: string;
  }> = ({ title, x, y, width, height, bgColor, textColor }) => (
    <div
      className="absolute rounded-lg border-2 border-blue-200 flex items-center justify-center shadow-sm"
      style={{
        left: x,
        top: y,
        width: width,
        height: height,
        backgroundColor: bgColor,
        color: textColor,
      }}
    >
      <span className="text-sm font-semibold text-center px-2">{title}</span>
    </div>
  );

  return (
    <div className="relative w-full h-[600px] bg-white rounded-2xl p-8 overflow-hidden shadow-lg border border-gray-200">
      
      {/* User Layer */}
      <ComponentBox
        title="Jobbveileder"
        x={350}
        y={40}
        width={160}
        height={50}
        bgColor="#F0F9FF"
        textColor="#1E40AF"
      />

      {/* Frontend Layer */}
      <ComponentBox
        title="Chat-grensesnitt"
        x={300}
        y={120}
        width={180}
        height={50}
        bgColor="#DBEAFE"
        textColor="#1E40AF"
      />

      {/* AI Processing Layer */}
      <ComponentBox
        title="Intent Analyzer"
        x={80}
        y={200}
        width={150}
        height={50}
        bgColor="#3B82F6"
        textColor="white"
      />

      <ComponentBox
        title="AI Koordinator"
        x={300}
        y={200}
        width={150}
        height={50}
        bgColor="#1D4ED8"
        textColor="white"
      />

      <ComponentBox
        title="Semantisk Søk"
        x={520}
        y={200}
        width={150}
        height={50}
        bgColor="#1E3A8A"
        textColor="white"
      />

      {/* API Layer */}
      <ComponentBox
        title="BRREG API"
        x={50}
        y={280}
        width={140}
        height={50}
        bgColor="#60A5FA"
        textColor="white"
      />

      <ComponentBox
        title="Utdanning.no"
        x={220}
        y={280}
        width={140}
        height={50}
        bgColor="#60A5FA"
        textColor="white"
      />

      <ComponentBox
        title="Arbeidsplassen"
        x={390}
        y={280}
        width={140}
        height={50}
        bgColor="#60A5FA"
        textColor="white"
      />

      {/* Security & Storage Layer */}
      <ComponentBox
        title="Privacy Guard"
        x={560}
        y={280}
        width={140}
        height={50}
        bgColor="#93C5FD"
        textColor="#1E40AF"
      />

      <ComponentBox
        title="Supabase Database"
        x={300}
        y={360}
        width={180}
        height={50}
        bgColor="#BFDBFE"
        textColor="#1E40AF"
      />

      {/* Legend */}
      <div className="absolute bottom-8 left-8 bg-blue-50 rounded-lg p-4 border border-blue-200">
        <h4 className="font-semibold mb-3 text-sm text-blue-900">Komponentkategorier:</h4>
        <div className="space-y-2 text-xs">
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded bg-blue-100 border border-blue-200"></div>
            <span className="text-blue-800">Brukerinteraksjon</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded bg-blue-500"></div>
            <span className="text-blue-800">AI & Intelligens</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded bg-blue-400"></div>
            <span className="text-blue-800">API Integrasjoner</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded bg-blue-300"></div>
            <span className="text-blue-800">Sikkerhet & Lagring</span>
          </div>
        </div>
      </div>

    </div>
  );
};

export default ProfessionalArchitectureDiagram;
